import React from "react";
import "./listing-approval-section.scss";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { useFormik } from "formik";
import { updateDealsApi } from "../../../../requests/dealApi";
import * as Yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";

const ListingApprovalSection = ({ deal }) => {
  const userFormik = useFormik({
    initialValues: {
      reason_of_rejection: "",
    },
    validationSchema: Yup.object({
      reason_of_rejection: Yup.string().required("Enter Reason of Rejection"),
    }),
    onSubmit: async(values) => {
      console.log("Form values:", values);
      const data = await updateDealsApi(deal._id, {rejectionReason: values.reason_of_rejection, approval: "rejected", merchantId: deal?.merchant, sendEmail: true})
      debugger
      if(data.status) {
        toast.success("deal has been rejected")
      } else {
        toast.error(data.message)
      }
     
    },
  });

  const pictures = [
    "/images/hotels/hotel-4.svg",
    "/images/hotels/hotel-1.svg",
    "/images/backgrounds/room-1.png",
    "/images/hotels/hotel-2.svg",
  ];

  console.log("=====this is deal", deal)

  const dealApproval = async () => {
    const data = await updateDealsApi(deal._id, { approval: 'approved'})
    if(data.status) {
      toast.success('Deal has been approved')
    } else {
      toast.error(data.message)
    }
  }

  return (
    <>
      <section className="listing-approval-page">
        <div className="listing-apprval-wrap">
          <h2>Deal Approval</h2>
          <div className="row">
            <div className="col-xl-3 col-md-6 p-2">
              <div className="kyc-box">
                <span>Deal Name</span>
                <p>{deal.dealName}</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 p-2">
              <div className="kyc-box">
                <span>Service Type</span>
                <p>{deal.serviceType}</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 p-2">
              <div className="kyc-box">
                <span>Valid From</span>
                <p>{moment(deal.start).format('YYYY-MM-DD')}</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 p-2">
              <div className="kyc-box">
                <span>Valid To</span>
                <p>{moment(deal.end).format('YYYY-MM-DD')}</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 p-2">
              <div className="kyc-box">
                <span>Discount</span>
                <p>{deal.discountPercentage}%</p>
              </div>
            </div>
          </div>
        </div>
        <div className="listing-apprval-wrap">
          <h2>Media</h2>
          <div className="media-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <h5>Pictures</h5>
                <PhotoProvider>
                  <div className="main-picture">
                    <PhotoView src={deal.file}>
                      <img
                        src={deal.file}
                        alt="Main Pic"
                        className="img-fluid"
                      />
                    </PhotoView>
                  </div>
                  {/* <div className="small-pictures">
                    {pictures.slice(1).map((pic, index) => (
                      <PhotoView key={index} src={pic}>
                        <img
                          src={pic}
                          alt={`pic-${index}`}
                          className="img-thumbnail small-thumb"
                        />
                      </PhotoView>
                    ))}
                  </div> */}
                </PhotoProvider>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="listing-apprval-wrap">
          <h2>Product Detail</h2>
          <div className="product-detail-content">
            <p>
              Explore one of the world’s most iconic landmarks with an expert
              local guide. Skip the long lines and get fast-track access to the
              Eiffel Tower’s second floor while learning about its history and
              engineering marvel.
            </p>
            <p>Inclusions:</p>
            <ul>
              <li>Guided access to 2nd floor</li>
              <li>English-speaking guide</li>
              <li>Entry ticket included</li>
            </ul>
            <p>Exclusions:</p>
            <ul>
              <li>Hotel pickup/drop-off</li>
              <li>Meals or beverages</li>
            </ul>
          </div>
        </div>
        <div className="listing-apprval-wrap">
          <h2>Sales Information</h2>
          <div className="row">
            <div className="col-xl-4 col-md-6 p-2">
              <div className="kyc-box">
                <span>Availability Details</span>
                <p>Everyday</p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 p-2">
              <div className="kyc-box">
                <span>Availability Timing</span>
                <p>Fixed - 0800 - 1800</p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 p-2">
              <div className="kyc-box">
                <span>Attraction Duration</span>
                <p>No Time Limit</p>
              </div>
            </div>
            <div className="col-lg-6 p-2">
              <div className="kyc-box">
                <span>Pricing</span>
                <div className="table-responsive">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          Adult <span>(Aged 12+)</span>
                        </td>
                        <td>
                          {" "}
                          <span>100,000</span>
                        </td>
                        <td>YEN</td>
                      </tr>
                      <tr>
                        <td>
                          Children <span>(3-11)</span>
                        </td>
                        <td>
                          {" "}
                          <span>50,000</span>
                        </td>
                        <td>USD</td>
                      </tr>
                      <tr>
                        <td>
                          Children <span>(1-2)</span>
                        </td>
                        <td>
                          {" "}
                          <span>1,000</span>
                        </td>
                        <td>SGD</td>
                      </tr>
                      <tr>
                        <td>
                          Toddler <span>(0-1)</span>
                        </td>
                        <td>
                          {" "}
                          <span>Free</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="listing-apprval-wrap action-btns">
          <button
            id="reject-btn"
            data-bs-toggle="modal"
            data-bs-target="#rejectListingModal"
          >
            Reject
          </button>
          <button id="approve-btn" onClick={dealApproval}>Approve</button>
        </div>
      </section>

      <div
        className="modal fade"
        id="rejectListingModal"
        tabIndex="-1"
        aria-labelledby="rejectListingModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content reject-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Reject Listing</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>
              <form className="reject-info">
                <p className="modal-note">
                  Are you sure you want to reject this listing?
                </p>
                <div className="user-inputs">
                  <div className="floating-label">
                    <textarea
                      name="reason_of_rejection"
                      value={userFormik.values.reason_of_rejection}
                      onChange={userFormik.handleChange}
                      onBlur={userFormik.handleBlur}
                    ></textarea>
                    <label className="floating-label-text">
                      Reason of Rejection
                    </label>
                    {userFormik.touched.reason_of_rejection &&
                      userFormik.errors.reason_of_rejection && (
                        <div className="error">
                          {userFormik.errors.reason_of_rejection}
                        </div>
                      )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn" onClick={userFormik.handleSubmit}>
                    Reject
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListingApprovalSection;
